<form [formGroup]="formData" class="text-start">
  <div class="mb-3 row" *ngFor="let item of controlsData; let i = index; let last = last">
    <div class="col-sm-12 mb-2">
      <label *ngIf="item.label && isQuePage" [for]="item.name" class="col-sm-12">
        <span>{{ i + 1 }}. &nbsp;</span><span class="dynamic-content title" #contentDiv [innerHtml]="item.label"></span>
      </label>

      <label *ngIf="item.label && !isQuePage" class="col-sm-12" [for]="item.name">
        <span class="col-form-label title" [innerHtml]="item.label"></span>
        <span *ngIf="item.options?.helpText && item.name.toLowerCase().includes('phone')" class="col-sm-2 fs-14">&nbsp;({{item.options?.helpText}})</span>
        <span *ngIf="item.validators?.required || item.required" class="col-sm-2 fs-14">&nbsp;(Required)</span>
      </label>

      <label *ngIf="!item.label && item.type!='hidden'" [for]="item.name" class="col-sm-12">
        <span class="col-form-label title">Enter the text</span>
        <span *ngIf="item.validators?.required || item.required" class="fs-14">&nbsp;(Required)</span>
      </label>

      <div *ngIf="item.options?.helpText != null && !item.name.toLowerCase().includes('phone')" class="col-sm-12">
        <span class="col-sm-2 fs-14" [innerHtml]="item.options?.helpText"></span>
      </div>
      <div *ngIf="typeof(item.helpText) !== 'undefined' && item.helpText !== null && !item.name.toLowerCase().includes('phone')" class="col-sm-12">
        <span class="col-sm-2 fs-14" [innerHtml]="item.helpText"></span>
      </div>
    </div>
    <div class="col-sm-12" [ngClass]="customClass">
      <input *ngIf="['text', 'password', 'search', 'url'].includes(item.type)"
        [placeholder]="item.placeholder ? item.placeholder : ''" [type]="item.type" [formControlName]="item.name"
        class="form-control" [id]="item.name" [name]="item.name" [value]="item.value" [(ngModel)]="item.value"
        [attr.maxlength]="item.validators.maxLength" (change)="modelChangeEvent($event, item)" aria-label="Text" />

      <input *ngIf="item.type === 'email'"  [placeholder]="item.placeholder ? item.placeholder : ''" type="email" [formControlName]="item.name"
        class="form-control" [id]="item.name" [name]="item.name" [readonly]="item.readonly === true"/>

      <span *ngIf="item.type === 'email' && formData.get(item.name)?.invalid && formData.get(item.name)?.touched && formData.get(item.name)?.value"
        class="error validation-color"> Enter a valid email. Example: email&#64;example.com</span>

      <input *ngIf="item.type === 'number'" [placeholder]="item.placeholder ? item.placeholder : ''" type="text"
        appNumberOnly [formControlName]="item.name" class="form-control" [id]="item.name" [name]="item.name"
        [value]="item.value" [ngModel]="item.value" [minlength]="item?.options?.minLength ?? 0"
        [maxlength]="item?.options?.maxLength ?? 250" pattern="[0-9]*" (ngModelChange)="modelChangeEvent($event, item)"
        aria-label="Number" />

      <input *ngIf="item.type === 'currency'" [placeholder]="item.placeholder ? item.placeholder : ''" type="text"
        appCurrency maxDigits="9" pattern="^(?![0,.]+$)(?:0|[1-9]\d{0,2}(?:,\d{3})*|[1-9]\d*)(?:\.\d{1,2})?$"
        [formControlName]="item.name" class="form-control" [id]="item.name" [name]="item.name" [value]="item.value"
        [ngModel]="item.value" [minlength]="item?.options?.minLength ?? 0" [maxlength]="item?.options?.maxLength ?? 250"
        (ngModelChange)="modelChangeEvent($event, item)" aria-label="Currency" autocomplete="off" />

      <input *ngIf="item.type === 'zip'" type="text" appZip [formControlName]="item.name" class="form-control" [id]="item.name"
        [name]="item.name" aria-label="Zip Code"/>
      <span *ngIf="item.type === 'zip' && formData.get(item.name)?.invalid && formData.get(item.name)?.touched && formData.get(item.name)?.value" class="error validation-color"> 
        Not valid. Use 5 or 9 digits (e.g., 12345 or 12345-6789) </span>
      
      <input *ngIf="item.type === 'ssn'" type="text" appSsn [formControlName]="item.name" class="form-control" [id]="item.name" 
        [name]="item.name" aria-label="SSN" />

      <span *ngIf="item.type === 'ssn' && formData.get(item.name)?.invalid && formData.get(item.name)?.touched && formData.get(item.name)?.value" class="error validation-color">
        Not valid, use 9 digits in format 111-22-3333</span>
      
      <input *ngIf="item.type === 'fax'" type="text" appFax [formControlName]="item.name" class="form-control" [id]="item.name"
        [name]="item.name" placeholder="123-456-7890" aria-label="Fax Number"/>

      <span *ngIf="item.type === 'fax' && formData.get(item.name)?.invalid && formData.get(item.name)?.touched" class="error validation-color">
            Not valid. Use 10-digit number (e.g., 123-456-7890)
      </span>

      <span *ngIf="item.type === 'date'" class="dateFieldOnlineReferrals">
        <p-datepicker 
          placeholder="MM/DD/YYYY" 
          [formControlName]="item.name" 
          [id]="item.name" 
          [(ngModel)]="item.value"
          [minDate]="item.options.min" 
          [maxDate]="item.options.max"
          (input)="formatDateToMMDDYYYY($event, item); onDateInput($event);modelChangeEvent($event, item)"
          (onClearClick)="formatDateToMMDDYYYY($event, item);modelChangeEvent($event, item)"
          (onSelect)="formatDateToMMDDYYYY($event, item);modelChangeEvent($event, item)" 
          [showButtonBar]="true"
          [showIcon]="true" 
          [showOnFocus]="false"
          (click)="onCalendarClick()"
          [ngClass]="{'is-invalid': formData.get(item.name)?.invalid && formData.get(item.name)?.touched}"
          inputStyleClass="form-control">
        </p-datepicker>
        <br />
        <span [id]="item.name+'_Error'" style="color: red;"></span>
        <span *ngIf="formData.get(item.name)?.errors?.['dateRangeInvalid']" class="error validation-color">
          {{ formData.get(item.name)?.errors?.['dateRangeInvalid']?.message }}
        </span>
      </span>

      <input *ngIf="item.type === 'phone'" type="tel" [formControlName]="item.name" class="form-control"
        [id]="item.name" [name]="item.name" [value]="item.value" [ngModel]="item.value"
        (ngModelChange)="modelChangeEvent($event, item)" aria-label="Phone" />

      <select *ngIf="item.type === 'select'" [ngClass]="controlWidth ? 'form-select width45p' : 'form-select'"
        [formControlName]="item.name" aria-label="Default select example" [id]="item.name" [(ngModel)]="item.value"
        (change)="modelChangeEvent($event, item)" [name]="item.name">
        <option value="" disabled selected>Select an option</option>
        <option [value]="option.value" *ngFor="let option of item.options">
          {{ option.key }}
        </option>
      </select>


      <textarea *ngIf="item.type === 'textarea'" class="form-control"
        [placeholder]="item.placeholder ? item.placeholder : ''" [formControlName]="item.name" [id]="item.name"
        [name]="item.name" [(ngModel)]="item.value" (ngModelChange)="modelChangeEvent($event, item)" [maxlength]="
          item.validators.maxLength ? item.validators.maxLength : null
        " [cols]="textAreaCol" [rows]="textAreaRows" aria-label="textArea"></textarea>
      <span class="fs-14" [ngClass]="textAreaCounterPositionClass"
        *ngIf="item.type === 'textarea' && item?.options.showCount" style="padding-top: 3px;">Character space remaining:
        {{ item.options.count | number }}</span>

      <input *ngIf="item.type=='hidden'" type="hidden" [formControlName]="item.name" class="form-control"
        [id]="item.name" [name]="item.name" [value]="item.value" [(ngModel)]="item.value"
        (change)="modelChangeEvent($event, item)" aria-label="Text" />
    </div>
    <div class="col-sm-2">
      <span class="fs-14" *ngIf="item.helperText">{{ item.helperText }}</span>
    </div>
    <hr class="mt-4" *ngIf="isQuePage" />
  </div>
</form>